import React from 'react';
import { OmGlyph, DiamondDivider } from './svgs';
import './Footer.css';

export default function Footer() {
  const handleNav = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <DiamondDivider color="#C9902A" />

      <div className="footer__inner section-container">
        <div className="footer__brand">
          <OmGlyph size={44} color="#F5C842" />
          <div>
            <p className="footer__name cinzel">Vedanagari</p>
            <p className="footer__sub devanagari">वेदनगरी आश्रम</p>
          </div>
        </div>

        <div className="footer__tagline">
          A sanctuary at the sacred foot of Arunachala —<br />
          open to all, sustained by grace.
        </div>

        <nav className="footer__links">
          {['#home','#about','#activities','#community','#contact'].map(href => (
            <button key={href} onClick={() => handleNav(href)} className="footer__link cinzel">
              {href.replace('#','').charAt(0).toUpperCase() + href.replace('#','').slice(1)}
            </button>
          ))}
        </nav>

        <div className="footer__contact">
          <a href="mailto:info@vedanagari.org">info@vedanagari.org</a>
          <span>·</span>
          <a href="tel:+919611701326">+91 96117 01326</a>
        </div>

        <p className="footer__copy">
          © {new Date().getFullYear()} Vedanagari Ashram · Tiruvannamalai, Tamil Nadu
        </p>

        <p className="footer__mantra devanagari">
          ॐ शान्तिः शान्तिः शान्तिः
        </p>
      </div>
    </footer>
  );
}
